export const getPartnerFlagTag = (flag: string) => {
  return `jbp-partner-flag-${flag}`.toLowerCase()
}
